// extracted by mini-css-extract-plugin
module.exports = {"massMailingListItemEmptyView":"MassMailingListItemEmptyView_massMailingListItemEmptyView__rpBTt"};